// extracted by mini-css-extract-plugin
module.exports = {"disclaimerBlock":"style_disclaimerBlock__cFvrx mds-typography-legacy-body-100"};